import React from 'react'

import { ArrowDropDown } from '@mui/icons-material'
import { Button, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material'

import { ReactComponent as AccountsIcon } from '../../../assets/icons/icon-accounts.svg'
import { Menus } from '../types'

type SelectedPeriodButtonType = {
  onClick: (menuKey: Menus, event: React.MouseEvent<HTMLElement>) => void
  currentAccountName: string
}

export const SelectAccountButton: React.FC<SelectedPeriodButtonType> = ({
  onClick,
  currentAccountName,
}) => {
  const { spacing, palette, breakpoints } = useTheme()

  const isMobile = useMediaQuery(breakpoints.down('md'))

  if (isMobile) {
    return (
      <IconButton
        className="filter-account"
        color="primary"
        onClick={(event) => onClick(Menus.accounts, event)}
      >
        <AccountsIcon />
      </IconButton>
    )
  }

  return (
    <Button
      className="filter-account"
      color="inherit"
      sx={{
        height: spacing(5.5),
        minWidth: spacing(24),
        p: spacing(1.25, 2),
        gap: 1,
        border: `1px solid ${palette.grey[500]}`,
        textTransform: 'none',
        borderRadius: spacing(2.75),
        '&:hover': {
          border: `1px solid ${palette.grey[700]}`,
          backgroundColor: 'transparent',
        },
      }}
      onClick={(event) => onClick(Menus.accounts, event)}
    >
      <AccountsIcon />
      <Typography flex="1" fontWeight={500} textAlign="left" color={'text.secondary'}>
        {currentAccountName}
      </Typography>
      <ArrowDropDown />
    </Button>
  )
}
